let uniqueId = 0;

export default function(){
    return 'uid-' + ++uniqueId;
}